import React, { useRef, useState } from "react";
import ResourceViewerHeader from "./ResourceViewerHeader";
import ContentPlayer from "../ContentViewer/ContentPlayer";
import PropTypes from "prop-types";
import ResourceViewerNavigationButtons from "./ResourceViewerNavigationButtons";
import ContentViewerActionButtons from "../ContentViewer/ContentViewerActionButtons";
import { Box } from "@mui/material";
import useCurrentApp from "../../hooks/utils/useCurrentApp";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

function ResourceViewer(props) {
  const currentApp = useCurrentApp();
  const [fullScreen, setFullScreen] = useState(false);
  const [iosFullScreen, setIosFullScreen] = useState(false);
  let iframeRef = useRef(null);
  const dispatch = useDispatch();

  const nextLink = !!props.nextLink ? `/${currentApp}/${props.nextLink}` : "";
  const prevLink = !!props.previousLink
    ? `/${currentApp}/${props.previousLink}`
    : "";
  const exitLink = `/${currentApp}/resources`;
  const LayoutComponent = props.LayoutComponent;

  const handleGoToNextResource = () => {
    dispatch(push(nextLink));
  };

  const handleGoToPreviousResource = () => {
    dispatch(push(prevLink));
  };

  const navigationButtons = (
    <ResourceViewerNavigationButtons
      previousLink={prevLink}
      nextLink={nextLink}
      onExitClick={() => props.onExit(exitLink)}
      onNextClick={handleGoToNextResource}
      onPreviousClick={handleGoToPreviousResource}
    />
  );
  return (
    <LayoutComponent title={props.sectionName}>
      <ResourceViewerHeader
        activityTitle={props.name}
        contentType={props.itemType}
        navigationButtons={navigationButtons}
      />
      <Box mt={1} mb={3}>
        <ContentViewerActionButtons
          fullScreen={fullScreen}
          onFullScreenChange={setFullScreen}
          allowFullScreen={
            (iframeRef && iframeRef.current) || props.contentType === "video"
          }
          downloadLink={props.downloadLink}
          contentType={props.itemType}
          fileType={props.mimeType}
        />
      </Box>
      <ContentPlayer
        closeNewTabAfterOpeningLink={props.closeNewTabAfterOpeningLink}
        openInNewTab={props.openInNewTab}
        contentLink={props.url}
        downloadLink={props.downloadLink}
        contentType={props.itemType}
        navigationButtons={navigationButtons}
        mimeType={props.mimeType}
        onFullScreenChange={setFullScreen}
        fullScreen={fullScreen}
        iframeRef={iframeRef}
        iosFullScreen={iosFullScreen}
        onIosFullScreenChange={setIosFullScreen}
      />
    </LayoutComponent>
  );
}

export default ResourceViewer;

ResourceViewer.propTypes = {
  contentType: PropTypes.string,
  itemType: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  previousLink: PropTypes.string,
  nextLink: PropTypes.string,
  downloadLink: PropTypes.string,
  repository: PropTypes.string,
  sectionName: PropTypes.string,
  LayoutComponent: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired
};
